import $ from 'jquery';

$(function(){
	
	// custom carousels for orangery site
	$('.carousel').each(function(){
		
		// config
		var $carousel = $(this);
		var $slides = $carousel.find('.slide');
		var slideSpeed = $carousel.data('speed');
		var delay = $carousel.data('delay');
		var options = $carousel.data('options');
		if(!slideSpeed) slideSpeed = 5000;
		if(!delay) delay = 0;
		var currentSlide = 0;
		var slideTimer;
		var pauseOnHover = true;
		var swipe = false;
		var forceHeight = false;
		var isHomeHero = ($(this).hasClass('workcarousel')) ? true : false;
		if(options) {
			if(options.search('nopause') !== -1) pauseOnHover = false;
			if(options.search('forceheight') !== -1) forceHeight = true;
			if(options.search('swipe') !== -1) swipe = true;
		}
		
		// set initial slide class
		$slides.eq(0).addClass('initial');
		
		// only initialise carousel if there is more than one slide
		if($slides.length > 1) {
			
			// force carousel element to fit largest slide (for carousels with variable height slides)
			if(forceHeight) {
				$(window).resize(function(){
					$slides.addClass('testheight');
					var h = 0;
					$slides.each(function(){
						h = Math.max(h, $(this).height());
					});
					$slides.removeClass('testheight');
					$carousel.css('min-height', h+'px');
				});
			}
		
			// move to slide x
			function goToSlide(newSlide) {
				if(!document['hidden'] && (newSlide != currentSlide)) {
					
					$slides.removeClass('initial slidein slideout');
					$slides.eq(currentSlide).addClass('slideout');
					$slides.eq(newSlide).addClass('slidein visible');
					$carousel.find('.dots a').removeClass('active');
					$carousel.find('.dots a').eq(newSlide).addClass('active');
					function setTimeOutWithClosure(currentSlide){ setTimeout(function(){ $slides.eq(currentSlide).removeClass('visible'); }, 1000); }
					setTimeOutWithClosure(currentSlide);
					currentSlide = newSlide;
					
					// if this is home hero carousel, switch header colours
					if(isHomeHero) { 
						if(newSlide == 0) $('header').removeClass('light').addClass('orange');
						else $('header').removeClass('orange').addClass('light');
					}
					
				}
				clearTimeout(slideTimer);
				slideTimer = setTimeout(nextSlide, slideSpeed);
			}
			
			// move to next slide
			function nextSlide() {
				var newSlide = ((currentSlide + 1) < $slides.length) ? currentSlide + 1 : 0;
				goToSlide(newSlide);
			}
			
			
			// move to previous slide
			function previousSlide() {
				var newSlide = ((currentSlide - 1) >= 0) ? currentSlide - 1 : ($slides.length - 1);
				goToSlide(newSlide);
			}
			
			// navigate carousel by clicking on progress dots
			$carousel.find('.dots a').click(function(e){
				e.preventDefault();
				var newSlide = $carousel.find('.dots a').index($(this));
				goToSlide(newSlide);
			});
			
			// handle pause on hover
			if(pauseOnHover) {
				$carousel.mouseenter(function(){
					clearTimeout(slideTimer);
				});
				$carousel.mouseleave(startSlideshow);
			}
			
			// handle swipe
			if(swipe) {
				var distanceThresholdRatio = .25;
				var hammertime = new Hammer($carousel[0]);
				hammertime.on('swipe', function(e){
					var distanceThreshold = $carousel.width() * distanceThresholdRatio;
					if(e.distance > distanceThreshold) {
						if(e.deltaX < 0) nextSlide();
						else previousSlide();
					}
				});
			}
			
			// go
			function startSlideshow() {
				clearTimeout(slideTimer);
				slideTimer = setTimeout(nextSlide, slideSpeed);
			}
			setTimeout(startSlideshow, delay);
			
		}
		
	});
	
});